import axios, { type AxiosError } from "axios";

export function isUnauthorizedError<Data>(
  error: unknown,
): error is AxiosError<Data> {
  return axios.isAxiosError(error) && error.response?.status === 403;
}

export function isNotFoundError<Data>(
  error: unknown,
): error is AxiosError<Data> {
  return axios.isAxiosError(error) && error.response?.status === 404;
}
